/**
 * General Purpose Functions
 */

/**
 * Returns whether a given element is within the viewport
 * 
 * @param {DOM Object} $elem     DOM Object you want
 * 
 * @return {string}             visible, above, below if the element is in view, above view, or below view respectively
 */
function elementInView($elem) {
	var windowHeight = $(window).height();
	var bottomOfScreen = $(window).scrollTop() + windowHeight;
	var topOfScreen = $(window).scrollTop();

	var elemHeight = $elem.height();
	var elemTop = $elem.offset().top;
	var elemBottom = $elem.offset().top + elemHeight;

	if( bottomOfScreen > elemTop && topOfScreen < elemBottom ) {
		return 'view';
	} else if( bottomOfScreen > elemTop && topOfScreen > elemBottom ) {
		return 'above';
	} else {
		return 'below';
	}
}

/**
 * Scales and image to a given container
 * 
 * @param {DOM Object}  $container  Container object
 * @param {DOM Object}  $image      Image object
 * @param {boolean}     contain     True if image should be contained instead of cover
 * 
 */
function scaleImageContainer($container, $image, contain) {
	var containerHeight = $container.height();
	var containerWidth  = $container.width();
	var imageWidth      = $image.get(0).naturalWidth;
	var imageHeight     = $image.get(0).naturalHeight;
	var newDimensions   = [];

	if( contain ) {
		newDimensions   = imgFitDimensions(imageWidth, imageHeight, containerWidth, containerHeight, 'contain');
	} else {
		newDimensions   = imgFitDimensions(imageWidth, imageHeight, containerWidth, containerHeight); 
	}

	var scaleFactorX    = newDimensions.width / containerWidth;
	var scaleFactorY    = newDimensions.height / containerHeight;

	var imageStyle      = $image.attr('style');
	var scaleRegex      = /scale\([^)]+\)/;

	if( contain && newDimensions.width > containerWidth && newDimensions.height > containerHeight ) {
		scaleFactorX    = 1;
		scaleFactorY    = 1;
	}

	if( imageStyle ) {
		imageStyle  = imageStyle.replace(scaleRegex, `scale(${scaleFactorX}, ${scaleFactorY})`);
		$image.attr('style', imageStyle);
	} else {
		imageStyle  = `translateY(0) scale(${scaleFactorX}, ${scaleFactorY})`;
		$image.css('transform', imageStyle);
	}
}

/**
 * Given the relation between where the screen is on the page,
 * image will get translated to create the sliding parallax effect.
 * 
 * Currently the image will slide by the max of either how much extra image there is 
 * available vertically after scaling or indicated slippage value (default 300).
 * 
 * This guarantees there will be no white space when the image is translated as well as,
 * not sliding so much that it is very unnatural.
 * 
 * I have not figured out a system yet to additionally scale the image for parallax if 
 * there's no imageOverflow vertically.
 * 
 * @param {DOM Object}  $container  General Container
 * @param {DOM Object}  $image      The image
 * @param {int}         slippage    Max amount in pixels that the image should translate.
 */
function parallaxImageContainer($container, $image, slippage) {
	var windowHeight = $(window).height();
	var bottomOfScreen = $(window).scrollTop() + windowHeight;
	slippage = slippage || 300;
	var imageHeight     = $image.height();

	var containerHeight = $container.outerHeight();
	var containerTop    = $container.offset().top;
	var translateRegex  = /translateY\([^)]*\)/;

	var imageOverflow   = (imageHeight - containerHeight) / 2;

	var travelDistance = Math.min(imageOverflow, slippage); // max parallax distance
	var imageStyle = $image.attr('style');
	var newStyle = imageStyle;

	var bannerScrolled = bottomOfScreen - containerTop;

	if( imageStyle ) {
		var containerOutputHigh = travelDistance;
		var containerOutputLow = -1 * travelDistance;
		var inputHigh = containerHeight + windowHeight; // total amount a user scrolls

		// Scale between values
		// Result := ((Input - InputLow) / (InputHigh - InputLow)) * (OutputHigh - OutputLow) + OutputLow;
		var bannerTranslate = ( (bannerScrolled)  / (inputHigh) ) * (containerOutputHigh - containerOutputLow) + containerOutputLow; 

		newStyle = imageStyle.replace(translateRegex, `translateY(${bannerTranslate}px)`);
		$image.attr('style', newStyle); 

	} else {
		imageStyle  = `translateY(0) scale(1, 1)`;
		$image.css('transform', imageStyle);
	}

}

/**
 * Calculates the necessary dimensions given an image, container, and calculation type.
 * 
 * @param {int}     imgWidth 
 * @param {int}     imgHeight 
 * @param {int}     containerHeight 
 * @param {int}     containerWidth 
 * @param {string}  type            Options for type of image scaling, contain or cover  
 * 
 * @return {Object}                 Contains the new width and height dimensions. Returns false on bad objects
 */
function imgFitDimensions(imgWidth, imgHeight, containerWidth, containerHeight, type) {
var imgRatio        = imgWidth / imgHeight;
var containerRatio  = containerWidth / containerHeight;
var test            = false;
var returnObj       = {};

switch(type) {
	case 'contain':
	test = (imgRatio > containerRatio); // for contain
	break;
	default:
	test = (imgRatio < containerRatio); // default cover
}

if( test ) {
	returnObj.width     = containerWidth;
	returnObj.height    = containerWidth / imgRatio;
} else {
	returnObj.width     = containerHeight * imgRatio;
	returnObj.height    = containerHeight;
}

return returnObj;
}